const yup = {
  error: {
    clientId: "ClientId is required",
    secret: "Secret key is required",
  },
};
export default yup;
